import { api } from "./api";

export const courseList = async (addUrl = ``) => {
  return api.get(`/courses?${addUrl}`);
};

export const courseAdd = async (data) => {
  return await api.post("/course/add", data);
};

export const courseUpdate = async (data) => {
  return await api.post(`/course/update`, data);
};

export const courseDelete = async (id) => {
  return await api.post(`/course/delete`, { id });
};

export const courseDetail = async (id) => {
  return await api.get(`/course/detail?id=${id}`);
};
